export const prepareConsentPayload = ({ ambntlistngConsentStatus, validateConfigData }) => {
  const clonedValidateConfig = JSON.parse(JSON.stringify(validateConfigData));
  clonedValidateConfig.ambntlistngConsentStatus = ambntlistngConsentStatus;
  return clonedValidateConfig;
};
